import { Time } from "./time";
import { Model } from "./model";

export class Candle extends Model {
	private time: Time = new Time();
	private unix: number = undefined;
	private open: string = "";
	private high: string = "";
	private close: string = "";
	private low: string = "";
	private dynamic: boolean = false;

	public getUnix(): number {
		return this.unix;
	}

	public getTime(): Time {
		return this.time;
	}

	public getOpen(): number {
		return +this.open;
	}

	public getHigh(): number {
		return +this.high;
	}

	public getClose(): number {
		return +this.close;
	}

	public getLow(): number {
		return +this.low;
	}

	public isDynamic(): boolean {
		return this.dynamic;
	}
}
